import styled from 'styled-components';
import { Subtitle } from 'packages/smart-home-support/components/Typography';

export default styled(Subtitle)`
  color: white;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/HeroSubtitle.tsx